import { render, staticRenderFns } from "./TipUnbond.vue?vue&type=template&id=64348662&scoped=true&"
import script from "./TipUnbond.vue?vue&type=script&lang=js&"
export * from "./TipUnbond.vue?vue&type=script&lang=js&"
import style0 from "./TipUnbond.vue?vue&type=style&index=0&id=64348662&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64348662",
  null
  
)

export default component.exports